export default __webpack_public_path__ + "static/media/online-exam-platform-3.74be7465.jpg";